import * as React from 'react';
import * as sanitizeHtml from 'sanitize-html';
import * as textile from 'textile-js';
import { generateId, Id } from '../common/Id';

/**
 * Test id attribute value (prefix) for certification note component.
 */
export const noteTestId: Id = 'certification-note';

/**
 * Props for certification note component.
 */
export interface NoteProps {
  note: string;
  id?: Id;
}

/**
 * Certification note component.
 * @param props - The props for this certifier user. Note that props are intersected with HTML props so that the styling can changed for
 * different use cases.
 */
export function NoteComponent(props: NoteProps & React.HTMLProps<HTMLDivElement>): React.ReactElement<NoteProps> {
  return (
    <div
      data-tb-test-id={generateId(noteTestId, props.id)}
      className={props.className}
      style={props.style}
      dangerouslySetInnerHTML={{ __html: sanitize(textile(props.note)) }}
    >
    </div>
  );
}

/**
 * Sanitizes HTML using the sanitizie-html module. Images need to be explicitly allowed since they are blocked by default.
 * @param dirtyHtml HTML string to sanitize
 */
export function sanitize(dirtyHtml: string): string {
  return sanitizeHtml(dirtyHtml, {
    allowedTags: sanitizeHtml.defaults.allowedTags.concat(['img'])
  });
}
